import React from 'react';
import ProtectedRoute from './protected';
import ReimbursementPage from '../pages/reimbursement';

export const ReimbursementRoutes = [
  <ProtectedRoute exact path='/reimbursements' component={ReimbursementPage} />,
];